import { getJobcloudDomain } from '@mkp/shared/util-environment';
import { EventCategory, EventCategoryParams } from '@mkp/tracking/models';

export const getEventCategory = ({
  name,
  category,
  action,
}: EventCategoryParams): EventCategory => ({
  tealium_event: name,
  event_action: action,
  event_category: category,
  event_name: name,
  event_origin: getJobcloudDomain(),
  event_source: 'application',
});
